import { WebRoutes } from "consts/enpoints/web";
import { Merchant } from "ui/forms/ECommerce";
import { Step, withApplication } from "ui/organizms/ECommerce/Onboarding/common";
import useMediaAndComplianceCheck from "./useMediaAndComplianceCheck";
import { useOnboardingApplication } from "../../hooks";

const MediaAndComplianceCheck = () => {
    const { getApplicationModel } = useOnboardingApplication();
    const mediaAndComplianceCheck = useMediaAndComplianceCheck();

    return (
        <Step
            title='Media & Compliance Check'
            getApplicationModel={getApplicationModel}
            route={WebRoutes.Onboarding.Merchant}
        >
            <Merchant.MediaAndComplianceCheck.Form
                {...mediaAndComplianceCheck}
            />
        </Step>
    );
};

export default withApplication(MediaAndComplianceCheck);
